<template>
    <div class="ma-2" outlined flat> 
        {{ connectionState }} [ {{  activeChannelCount }} ] 
        <span class="cursor-pointer text-primary" @click="echoDump">dump</span>
    </div>
</template>

<script setup>
    import useEcho from "@lib/useEcho"
    const {
        connectionState,
        isConnected,
        isReconnecting,
        lastError,
        activeChannelCount,
        joinedChannels,
        joinPublic,
        joinPrivate,
        joinPresence,
        leave,
        leaveAll,
        echoDump,
    } = useEcho();

</script>